module.exports = __webpack_public_path__ + "static/media/ikeda.88b4fc6e.jpg";